import config from 'config';
import { inject } from 'mobx-react';
import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { Socket } from 'react-socket-io';

import {
  CourseDetail,
  Courses,
  Institucional,
  PostList,
  Product,
  SaleDetail,
  SaleList
} from '../screens';
import DocumentList from '../screens/DocumentList';

//import { Header, Footer } from '../components';
//import Faqs from '../components/Faqs';

const uri = config.socket.baseURL;
const options = {};

@inject('ProductStore')
export default class AuthenticatedArea extends Component {
  componentWillMount() {
    const { ProductStore } = this.props;
    ProductStore.fetchData();
  }

  render() {
    return (
      <Socket uri={uri} options={options}>
        <div className="wrapper">
          <Route path="/institucional" component={Institucional} />
          <Route path="/novidades" component={PostList} />
          <Route path="/material-de-apoio" component={DocumentList} />

          <Route path="/ofertas-e-combos" component={SaleList} exact={true} />
          <Route path="/ofertas-e-combos/:sale_slug" component={SaleDetail} />
          <Route path="/p/:section_slug/:product_slug" component={Product} />

          <Route path="/cursos" component={Courses} exact={true} />
          <Route path="/cursos/ver/:slug" component={CourseDetail} />
        </div>
      </Socket>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/AuthenticatedArea.js